import {stage} from './stage';

// CloudWatch RUM (real user monitoring) config, per stage.
//
// 🛑 SHIPS DISABLED ON EVERY STAGE, DELIBERATELY. Whether RUM is on is a
// PLATFORM decision (PLATFORM_COMPLIANCE_CHECKLIST §2, FNP-1120), not an
// app decision. RUM writes to a real CloudWatch resource and bills per
// session, so do not flip `isEnabled` here during unrelated work.
//
// As of the last platform audit, 0 of 9 apps initialize RUM — every
// main.tsx carries a commented-out `import './init/cloudwatch-rum'`. The
// config exists so that when the platform does turn it on, the change is
// one line per app rather than a file-writing exercise.
//
// FILL IN only when the platform ticket says to: the applicationId,
// guestRoleArn and identityPoolId come from the RUM app monitor
// provisioned for THIS application. Leave them as 'xxxx' until then —
// a placeholder that is obviously a placeholder beats a real-looking id
// copied from another app.
type RumStageConfig = {
    isEnabled: boolean;
    applicationId: string;
    applicationVersion: string;
    applicationRegion: string;
    config: {
        sessionSampleRate: number;
        guestRoleArn: string;
        identityPoolId: string;
        endpoint: string;
        telemetries: string[];
        allowCookies: boolean;
        enableXRay: boolean;
    };
};

const defaults = {
    isEnabled: false,
    applicationId: 'xxxx',
    applicationVersion: '1.0.0',
    applicationRegion: 'us-west-2',
    config: {
        sessionSampleRate: 1,
        guestRoleArn: 'xxxx',
        identityPoolId: 'xxxx',
        endpoint: 'https://dataplane.rum.us-west-2.amazonaws.com',
        telemetries: ['errors', 'performance', 'http'],
        allowCookies: false,
        enableXRay: false,
    },
};

const rum: Record<'prod' | 'test' | 'dev' | 'ide', RumStageConfig> = {
    prod: {...defaults, config: {...defaults.config}},
    test: {...defaults, config: {...defaults.config}},
    dev: {...defaults, config: {...defaults.config}},
    ide: {...defaults, config: {...defaults.config}},
};

export default rum[stage] ?? rum.dev;
